/**
 * 横断図生成
 */
import color from "../scss/color.scss";
import tmObs from "./tmObs";
export default {
  DrawCross,
};

// 描画用の定数

// グラフ左余白
const paddingLeft = 30;
// グラフ右余白
const paddingRight = 40;
// ViewBoxを実際のサイズの何倍で描画するかの指定
const viewBoxRate = 2;
// スクロールバー高さ
const scrollHeight = 20;
// スライダー高さ
const sliderHeight = 30;
// 凡例表示位置
const yLegend = 10;

// 凡例の幅
const legendWidth = 480;
// 凡例の高さ（通常水位）
// const legendHeight = 370;
// 凡例の高さ（危機管理型水位計）
// const legendHeightSw = 230;
// 凡例の高さ（通常水位モバイル）
// const legendHeightMb = 180;
// 凡例の高さ（危機管理型水位計モバイル）
// const legendHeightSwMb = 150;

// スケール位置
const xScale = 10;

/**
 * コンストラクタ
 * @param {} setting
 * @param {*} crossData
 * @param {}
 */
function DrawCross(setting, crossData, historyIndex) {
  this.cross = crossData;
  this.history = historyIndex;

  // 実際の表示幅
  this.windowWidth = setting.windowWidth;
  // 実際の表示高
  this.windowHeight = setting.windowHeight;
  // スクロールバー表示モード
  this.scrollMode = setting.scrollMode;
  // 凡例表示モード
  this.showLegend = setting.showLegend;
  // 詳細表示モード
  this.detailMode = setting.detailMode;
  // ポップアップ表示モード
  this.popupMode = setting.popupMode;
  // マーカー表示モード
  this.markerMode = setting.markerMode;
  // 凡例分割表示モード
  this.legendDivisionMode = setting.legendDivisionMode;
  // 水防団モード
  this.isFldCtl = setting.isFldCtl;
}

/**
 * スクロールの変更イベント
 */
DrawCross.prototype.changeScroll = function(scrollLeft, elmSvg) {
  this.legendScroll = scrollLeft * this.graphScrollRatio;
  var gScale = elmSvg.children["g_scale"];
  gScale.setAttribute("transform", "translate(" + this.legendScroll + ",0 )");
  var gLegend = elmSvg.children["g_legend"];
  gLegend.setAttribute(
    "transform",
    "translate(" + this.legendScroll + "," + 0 + " )"
  );
};

/**
 * 凡例の表示・非表示切替イベント
 */
DrawCross.prototype.changeLegend = function(isShow, elmSvg) {
  var gLegend = elmSvg.children["g_legend"];
  if (isShow) {
    gLegend.setAttribute("visibility", "visible");
  } else {
    gLegend.setAttribute("visibility", "hidden");
  }
};

/**
 * 水位インデックス変更イベント
 */
DrawCross.prototype.changeStageIdx = function(stageIdx, elmSvg) {
  var cross = this.cross;
  this.history = stageIdx;
  var gCross = elmSvg.children["g_cross"];
  var polyStage = gCross.children["poly_stage"];
  var lineStage = gCross.children["line_stage"];
  var lineStageV = gCross.children["line_stage_v"];
  var labelElStage = gCross.children["label_el_stage"];
  var labelStage = gCross.children["label_stage"];

  // -----------------------------------------------------------------------
  // 水位ポリゴンの描画を修正
  // 最新観測値を取得
  let lastStage = 0;
  let lastStg = 0;
  if (this.history < cross.stages.length) {
    lastStage = cross.stages[cross.stages.length - this.history - 1].elevation;
    lastStg = cross.stages[cross.stages.length - this.history - 1].stg;
    if (lastStage == null) {
      // 水位がない場合は、欠測表示する
      this.labelStage = cross.allStageNullMes;
      labelStage.textContent = "";
      labelStage.appendChild(document.createTextNode(this.labelStage));
      var p = "0,0 0,0 0,0 0,0";
      polyStage.setAttribute("points", p);
      // 水位の横ラインを非表示
      lineStage.setAttribute("class", "cross-line-none");
      // 水位標高ラインから堤防天端の高さラベルまでの縦ラインを非表示
      if (lineStageV != null) {
        lineStageV.setAttribute("class", "cross-line-none");
      }
      // 水位のEL値を非表示
      if (labelElStage != null) {
        labelElStage.textContent = "";
      }

      return;
    }

    // 超過判定に応じて着色する
    if (this.stgMode === "0") {
      if (
        this.isFldStg &&
        lastStage >=
          tmObs.formatFloat(
            Math.round(
              (cross.levelValue.stageLvl5.stg + cross.zeroHighFix) * 100
            ) / 100,
            2
          )
      ) {
        // 堤防天端高を超える水位も描画可能とする
        // lastStage = cross.levelValue.stageLvl5.value;
        this.stageFillClass = "cross-fill-stage-lv5";
      } else if (
        this.isLv4 &&
        lastStage >=
          tmObs.formatFloat(
            Math.round(
              (cross.levelValue.stageLvl4.stg + cross.zeroHighFix) * 100
            ) / 100,
            2
          )
      ) {
        this.stageFillClass = "cross-fill-stage-lv4";
      } else if (
        this.isLv3 &&
        lastStage >=
          tmObs.formatFloat(
            Math.round(
              (cross.levelValue.stageLvl3.stg + cross.zeroHighFix) * 100
            ) / 100,
            2
          )
      ) {
        this.stageFillClass = "cross-fill-stage-lv3";
      } else if (
        this.isLv2 &&
        lastStage >=
          tmObs.formatFloat(
            Math.round(
              (cross.levelValue.stageLvl2.stg + cross.zeroHighFix) * 100
            ) / 100,
            2
          )
      ) {
        this.stageFillClass = "cross-fill-stage-lv2";
      } else if (
        this.isLv1 &&
        lastStage >=
          tmObs.formatFloat(
            Math.round(
              (cross.levelValue.stageLvl1.stg + cross.zeroHighFix) * 100
            ) / 100,
            2
          )
      ) {
        this.stageFillClass = "cross-fill-stage-lv1";
      } else {
        this.stageFillClass = "cross-fill-stage";
      }
    } else {
      if (this.isFldStg && lastStage >= cross.levelValue.stageLvl5.value) {
        // 堤防天端高を超える水位も描画可能とする
        // lastStage = cross.levelValue.stageLvl5.value;
        this.stageFillClass = "cross-fill-stage-lv5";
      } else if (this.isLv4 && lastStage >= cross.levelValue.stageLvl4.value) {
        this.stageFillClass = "cross-fill-stage-lv4";
      } else if (this.isLv3 && lastStage >= cross.levelValue.stageLvl3.value) {
        this.stageFillClass = "cross-fill-stage-lv3";
      } else if (this.isLv2 && lastStage >= cross.levelValue.stageLvl2.value) {
        this.stageFillClass = "cross-fill-stage-lv2";
      } else if (this.isLv1 && lastStage >= cross.levelValue.stageLvl1.value) {
        this.stageFillClass = "cross-fill-stage-lv1";
      } else {
        this.stageFillClass = "cross-fill-stage";
      }
    }
  } else {
    let idx =
      cross.stagesPrediction.length - (this.history - cross.stages.length) - 1;
    lastStage = cross.stagesPrediction[idx].elevation;
    lastStg = cross.stagesPrediction[idx].stg;
    this.stageFillClass = "cross-fill-prediction";
  }

  // 横断図上に表示する水位ラベルを設定
  if (this.stgMode === "0") {
    this.labelStage =
      this.cross.obsLabelZeroHigh +
      " " +
      tmObs.formatFloat(Math.round(lastStg * 100) / 100, 2) +
      "m";
  } else {
    this.labelStage =
      this.cross.obsLabel +
      " " +
      tmObs.formatFloat(Math.round((lastStage - cross.upgate) * 100) / 100, 2) +
      "m";
  }

  var height =
    this.viewBoxHeight - this.yP * (lastStage - this.min) - this.lowHeight;
  // 水位ELラベルのy座標を指定
  this.yLabelElStage = height;
  // 水位ELラベルのテキストを指定
  this.labelElStage = "(EL=" + Math.round(lastStage * 100) / 100 + "m)";

  var maxHeight = this.viewBoxHeight;

  // ポリゴンのpointを再設定
  var point = this.xLeftBank + "," + height;
  point += " " + this.xRightBank + "," + height;
  point += " " + this.xRightBank + "," + maxHeight;
  point += " " + this.xLeftBank + "," + maxHeight;
  polyStage.setAttribute("points", point);
  polyStage.setAttribute("class", this.stageFillClass);

  // -----------------------------------------------------------------------
  // 水位ラインの描画を修正
  lineStage.setAttribute("y1", height);
  lineStage.setAttribute("y2", height);
  lineStage.setAttribute("class", "cross-stage");
  // 堤防天端から～ラベルと水位ラインまでの縦線の描画を修正
  lineStageV.setAttribute("y1", height);
  lineStageV.setAttribute("class", "cross-stage-center");
  // 水位ELラベルの描画を修正
  labelElStage.textContent = null;
  labelElStage.appendChild(document.createTextNode(this.labelElStage));
  labelElStage.setAttribute("y", this.yLabelElStage - 10);
  // 水位ラベルの描画を修正
  labelStage.textContent = null;
  labelStage.appendChild(document.createTextNode(this.labelStage));
};

/**
 * SVGを生成して返却
 */
DrawCross.prototype.svg = function() {
  // svgタグを生成
  let svg = document.createElement("svg");
  svg.setAttribute("xmlns", "http://www.w3.org/2000/svg");
  svg.setAttribute("id", "svg_cross");
  svg.setAttribute("error", "");
  svg.setAttribute("exception", "");
  svg.setAttribute("class", "cross-svg");

  try {
    // 描画情報の設定
    this.setDrawData();
    svg.setAttribute("viewBox", this.viewBox);
    svg.setAttribute("width", this.svgWidth + "px");
    svg.setAttribute("height", this.svgHeight + "px");
    // styleタグを生成
    svg.appendChild(this.getStyle());

    // gタグを生成
    var g = document.createElement("g");
    g.setAttribute("id", "g_cross");

    // 水位の背景ポリゴンを追加
    let polStage = this.getStagePolygon();
    if (polStage) {
      g.appendChild(polStage);
    }

    if (this.cross.drawType == 2) {
      // 特殊横断の場合

      // 標高ポリゴンを追加
      g.appendChild(this.getPointsPolygonSp());
      // 標高ラインを追加
      appendLine(g, this.getPointsLineSp());
    } else {
      // 標高ポリゴンを追加
      g.appendChild(this.getPointsPolygon());
      // 標高ラインを追加
      appendLine(g, this.getPointsLine());
      // A点の縦ラインを追加
      // B点の縦ラインを追加
      // 現在地の縦ラインを追加
      appendLine(g, this.getVerticalLine());
      // A点マーカーを追加
      // B点マーカーを追加
      // 現在地マーカーを追加
      if (this.markerMode) {
        appendImage(g, this.getMarkers());
      }
    }

    // 基準値ラインを追加
    // 水位ラインを追加
    appendLine(g, this.getLevelLine());
    // 堤防天端からの高さを追加
    appendLine(g, this.getStageLine());

    // 各ラベルを追加
    appendText(g, this.getText());

    svg.appendChild(g);

    // スケールを追加
    var gScale = document.createElement("g");
    gScale.setAttribute("id", "g_scale");
    appendLine(gScale, this.getScaleLine());
    // スケールラベルを追加
    appendText(gScale, this.getScaleText());
    svg.appendChild(gScale);

    var gLegend = document.createElement("g");
    gLegend.setAttribute("id", "g_legend");
    // 凡例表示・非表示を切り替える
    if (!this.showLegend) {
      gLegend.setAttribute("visibility", "hidden");
    }
    // 凡例を追加
    // if (this.cross.sys === "sw") {
    //   // 危機管理型水位計の凡例の名称を追加
    //   appendText(gLegend, this.getLegendTextSw());
    // } else {
    //   // 通常水位の凡例の名称を追加
    //   appendText(gLegend, this.getLegendText());
    // }
    this.legendRectHeight = 0;
    let legendValues = [];
    if (this.cross.sys === "sw") {
      // 危機管理型水位計の凡例の名称を追加
      legendValues = this.getLegendTextSw();
    } else {
      // 通常水位の凡例の名称を追加
      legendValues = this.getLegendText();
    }
    appendRect(gLegend, this.getLegendRect());
    appendText(gLegend, legendValues);

    // 凡例のポイントから基準値までのラインを描画
    appendLine(gLegend, this.getLegendLine());
    // 凡例のプロットを描画
    appendCircle(gLegend, this.getLegendCircle());
    svg.appendChild(gLegend);
  } catch (ex) {
    // console.dir(ex);
    svg = document.createElement("svg");
    svg.setAttribute("xmlns", "http://www.w3.org/2000/svg");
    svg.setAttribute("id", "svg_cross");
    svg.setAttribute("error", "横断図の描画に失敗しました。");
    svg.setAttribute("exception", ex);
  }

  return svg;
};

/**
 * Styleタグを生成
 */
DrawCross.prototype.getStyle = function() {
  // CSSをstyleタグに設定
  var style = document.createElement("style");
  style.type = "text/css";
  var css = ` .cross-svg {
    background-color:#CFCFCF;
  }
  .cross-line-normal {
  stroke: slategray;
    stroke-width: 2;
    stroke-linecap: round;
    stroke-linejoin: round;
  }
  .cross-line-out-blank {
    stroke: midnightblue;
    stroke-width: 2;
    stroke-linecap: round;
    stroke-linejoin: round;
  }
  .cross-line-parent {
    stroke: pink;
    stroke-width: 2;
    stroke-linecap: round;
    stroke-linejoin: round;
  }
  .cross-fill-normal {
    fill: #A7A799;
    stroke: #A7A799;
    stroke-width: 1;
  }
  .cross-fill-stage {
    fill: ${color.tmStgNormal};
    stroke: #e5e5e5;
    stroke-width: 1;
  }
  .cross-fill-prediction {
    fill: ${color.stagePrediction};
    stroke: #e5e5e5;
    stroke-width: 1;
  }
  .cross-fill-stage-lv1 {
    fill: ${color.tmStgFldctl};
    stroke: #e5e5e5;
    stroke-width: 1;
  }
  .cross-fill-stage-lv2 {
    fill: ${color.tmStgWarn};
    stroke: #e5e5e5;
    stroke-width: 1;
  }
  .cross-fill-stage-lv3 {
    fill: ${color.tmStgRefuge};
    stroke: #e5e5e5;
    stroke-width: 1;
  }
  .cross-fill-stage-lv4 {
    fill: ${color.tmStgDanger};
    stroke: #e5e5e5;
    stroke-width: 1;
  }
  .cross-fill-stage-lv5 {
    fill: ${color.tmStgFlood};
    stroke: #e5e5e5;
    stroke-width: 1;
  }
  .cross-stage {
    stroke: ${color.tmStgNormal};
    stroke-width: 3;
    stroke-linecap: round;
    stroke-linejoin: round;
  }
  .cross-line-none {
    stroke-width: 0;
  }
  .cross-stage-center {
    stroke: ${color.tmStgNormal};
    stroke-width: 3;
    stroke-linecap: round;
    stroke-linejoin: round;
  }
  .cross-point {
    stroke: midnightblue;
    stroke-width: 2;
    stroke-linecap: round;
    stroke-linejoin: round;
  }
  .cross-stroke-leve-stageLvl1 {
    stroke: ${color.tmStgFldctl};
    stroke-width: 3;
    stroke-linecap: round;
    stroke-linejoin: round;
  }
  .cross-stroke-leve-stageLvl2 {
    stroke: ${color.tmStgWarn};
    stroke-width: 2;
    stroke-linecap: round;
    stroke-linejoin: round;
  }
  .cross-stroke-leve-stageLvl3 {
    stroke: ${color.tmStgRefuge};
    stroke-width: 2;
    stroke-linecap: round;
    stroke-linejoin: round;
  }
  .cross-stroke-leve-stageLvl4 {
    stroke: ${color.tmStgDanger};
    stroke-width: 2;
    stroke-linecap: round;
    stroke-linejoin: round;
  }
  .cross-stroke-leve-stageLvl5 {
    stroke: ${color.tmStgFlood};
    stroke-width: 2;
    stroke-linecap: round;
    stroke-linejoin: round;
  }
  .cross-stroke-present {
    stroke: pink;
    stroke-width: 3;
    stroke-linecap: round;
    stroke-linejoin: round;
  }
  .cross-stroke-zero{
    stroke: brown;
    stroke-width: 3;
    stroke-linecap: round;
    stroke-linejoin: round;
  }
  .cross-scale-line {
    stroke: black;
    stroke-width: 2;
  }
  .label {
    fill: black;
    font-weight: bold;
    font-size: 23px;
  }
  .label-el-stage {
    fill: rgb(50, 50, 255);
  }
  .label-stage {
    fill: rgb(50, 50, 255);
    font-weight: bold;
    font-size: 40px;
  }
  .label-stage-mb {
    fill: rgb(50, 50, 255);
    font-weight: bold;
    font-size: 30px;
  }
  .label-zero {
    fill: rgb(143, 101, 82);
  }
  .legend {
    fill: rgb(155, 193, 247);
    stroke: dodgerblue;
    stroke-width: 2;
    opacity: 0.9;
  }
  .legend-text {
    font-weight: bold;
    font-size: 28px;
  }
  .legend-text-mb {
    font-weight: bold;
    font-size: 17px;
  }
  .legend-lv-1 {
    fill: ${color.tmStgFldctl};
  }
  .legend-lv-2 {
    fill: ${color.tmStgWarn};
  }
  .legend-lv-3 {
    fill: ${color.tmStgRefuge};
  }
  .legend-lv-4 {
    fill: ${color.tmStgDanger};
  }
  .legend-lv-5 {
    fill: ${color.tmStgFlood};
  }
  .legend-explanation {
    font-weight: normal;
    font-size: 25px;
  }
  .legend-explanation-mb {
    font-weight: normal;
    font-size: 16px;
  }
  .legend-message {
    font-weight: normal;
    font-size: 22px;
  }
  .legend-message-mb {
    font-weight: normal;
    font-size: 15px;
  }
  .legend-stroke {
    stroke: rgb(0, 0, 0);
    stroke-width: 2;
    stroke-linecap: round;
    stroke-linejoin: round;
  }`;

  style.appendChild(document.createTextNode(css));

  return style;
};

/**
 * 描画情報の算出
 */
DrawCross.prototype.setDrawData = function() {
  // ViewBoxの幅を設定
  if (this.scrollMode) {
    this.viewBoxWidth =
      this.windowWidth * this.cross.drawWidthMag * viewBoxRate;
  } else {
    this.viewBoxWidth = this.windowWidth * viewBoxRate;
  }
  // ViewBoxの高さ
  this.viewBoxHeight =
    (this.windowHeight - scrollHeight - sliderHeight) * viewBoxRate;

  this.viewBox = "0 0 " + this.viewBoxWidth + " " + this.viewBoxHeight;

  // SVGタグの幅
  if (this.scrollMode) {
    this.svgWidth = this.windowWidth * this.cross.drawWidthMag;
  } else {
    this.svgWidth = this.windowWidth;
  }
  // SVGタグの高さ
  this.svgHeight = this.windowHeight - scrollHeight - sliderHeight;

  // PC・モバイル表示
  this.mode = this.cross.mode;
  // 水位表示
  this.stgMode = this.cross.stgMode;

  // 最大値・最小値を再判定
  this.max = this.cross.drawMaxValue;
  this.min = this.cross.drawMinValue;

  this.isFldStg = true;

  // 描画上限が指定されていない場合は、縦データの最大を上限とする
  if (!this.max) {
    let maxHeight = 0;
    this.isFldStg = false;
    // 横断データの件数分ループ
    for (let idx in this.cross.pointsOutBank) {
      let p = this.cross.pointsOutBank[idx];
      if (isEmpty(p.drawLength) || isEmpty(p.drawHeight)) continue;

      let height = p.drawHeight;

      // 縦位置確認ライン
      if (isEmpty(height)) continue;

      if (this.cross.sfLeftLimit && this.cross.sfRightLimit) {
        if (
          p.drawLength < this.cross.sfLeftLimit ||
          p.drawLength > this.cross.sfRightLimit
        ) {
          continue;
        }
      }
      if (maxHeight < height) {
        maxHeight = height;
      }
    }
    this.max = maxHeight;
    // 縦データもない場合は、標高データの最大を上限とする
    if (!this.max) {
      maxHeight = 0;
      for (let idx in this.cross.points) {
        let p = this.cross.points[idx];
        [idx];
        if (maxHeight < p.h) {
          maxHeight = p.h;
        }
      }
      this.max = maxHeight;
    }
    this.stgMode = "0";
  }

  // 零点高が描画下限より高い場合は、零点高-1mを下限とする
  // let disMinZero = this.min - this.cross.zeroHighFix;

  this.isZeroLine = true;
  if (this.min - 1 > this.cross.zeroHighFix) {
    this.isZeroLine = false;
  }

  if (this.isZeroLine && this.min > this.cross.zeroHighFix) {
    this.min = this.cross.zeroHighFix - 1;
  }

  if (isEmpty(this.cross.drawPosMax) == false) {
    // 描画上限・下限を取得
    this.upperPos = this.cross.drawPosMax / 100;
  } else {
    if (isEmpty(this.cross.highCfg1)) {
      this.upperPos = 40 / 100;
    } else {
      this.upperPos = this.cross.highCfg1 / 100;
    }
  }

  if (isEmpty(this.cross.drawPosMin) == false) {
    this.lowerPos = this.cross.drawPosMin / 100;
  } else {
    if (isEmpty(this.cross.lowCnf1)) {
      this.lowerPos = 10 / 100;
    } else {
      this.lowerPos = this.cross.lowCnf1 / 100;
    }
  }
  this.uppHeight = this.viewBoxHeight * this.upperPos;
  this.lowHeight = this.viewBoxHeight * this.lowerPos;

  // 描画の最大域を取得
  let totalY = this.max - this.min;

  let totalX = this.cross.totalDistance;
  // 特殊横断の場合は総距離を横断データから再設定する
  if (this.cross.drawType == 2) {
    totalX =
      this.cross.pointsOutBank[this.cross.pointsOutBank.length - 1].drawLength -
      this.cross.pointsOutBank[0].drawLength;
  } else {
    // 特殊横断以外の場合は堤外地の限界点座標のインデックスを予め保持する
    if (this.cross.sfLeftLimit != null && this.cross.sfRightLimit != null) {
      this.leftOutBankIdx = -1;
      this.rightOutBankIdx = -1;
      for (let idx in this.cross.pointsOutBank) {
        let p = this.cross.pointsOutBank[idx].drawLength;
        if (p < this.cross.sfLeftLimit) {
          continue;
        } else if (this.leftOutBankIdx < 0) {
          this.leftOutBankIdx = idx;
        }
        if (p < this.cross.sfRightLimit) {
          continue;
        } else {
          this.rightOutBankIdx = idx;
          break;
        }
      }
    } else {
      this.cross.pointsOutBank = [];
    }

    // 堤外地は描画比率が違うため、補正する
    if (this.cross.pointsOutBank.length > 0) {
      let pointLeftDis = this.cross.points[this.cross.leftBankIdx].distance;
      let pointRightDis = this.cross.points[this.cross.rightBankIdx].distance;
      let outLeftDis = this.cross.pointsOutBank[this.leftOutBankIdx].drawLength;
      let outRightDis = this.cross.pointsOutBank[this.rightOutBankIdx]
        .drawLength;

      let sur = outRightDis - outLeftDis;
      let surInterval = this.cross.rvrwid / sur;
      let drawLength = (sur / 1000) * surInterval;
      this.adjusted = pointLeftDis + drawLength - pointRightDis;
      totalX += this.adjusted;
    }
  }

  // 凡例分割モードの場合は、
  if (this.legendDivisionMode) {
    this.xP =
      (this.viewBoxWidth - paddingLeft - paddingRight - legendWidth - 20) /
      totalX;
  } else {
    this.xP = (this.viewBoxWidth - paddingLeft - paddingRight) / totalX;
  }

  this.yP = (this.viewBoxHeight * (1 - this.upperPos - this.lowerPos)) / totalY;

  if (this.mode === "mb") {
    this.xLegend = this.windowWidth * 2 - 520;
  } else {
    this.xLegend = this.windowWidth * 2 - 550;
  }

  if (this.cross.isPresentOut) {
    // this.maxPointsIdx = this.cross.points.length - 1;
    this.maxPointsIdx = this.cross.points.length;
  } else {
    // this.maxPointsIdx = 300;
    this.maxPointsIdx = this.cross.BIdx + 1;
  }

  // スクロールバーの初期値
  this.legendScroll = 30;
  // スクロール距離
  this.graphScrollRatio = 2;

  // 凡例描画マージン
  this.legendLetMargin = 40;
  // 凡例枠のプロットのx座標
  this.xStandardProd = 20;
  this.xStandardLine = -200;
  this.xStandardLineMb = -80;
};

/**
 * 水位ポリゴンを生成
 */
DrawCross.prototype.getStagePolygon = function() {
  var cross = this.cross;

  var leftBankIdx = cross.leftBankIdx;
  var rightBankIdx = cross.rightBankIdx;

  this.isLv4 = false;
  this.isLv3 = false;
  this.isLv2 = false;
  this.isLv1 = false;
  if (this.cross.levelValue.stageLvl4.value != null) {
    this.isLv4 = true;
  }
  if (this.cross.levelValue.stageLvl3.value != null) {
    this.isLv3 = true;
  }
  if (this.cross.levelValue.stageLvl2.value != null) {
    this.isLv2 = true;
  }
  if (this.cross.levelValue.stageLvl1.value != null && this.isFldCtl) {
    this.isLv1 = true;
  }

  if (cross.drawType === 2) {
    var leftLength = cross.pointsOutBank[0].drawLength;
    // var leftBankSp =
    //   cross.pointsOutBank[cross.leftBankIdx].drawLength - leftLength;
    let leftBankSp = cross.sfLeftLimit - leftLength;
    // var rightBankSp =
    //   cross.pointsOutBank[cross.rightBankIdx].drawLength - leftLength;
    let rightBankSp = cross.sfRightLimit - leftLength;
    this.xLeftBank = this.xP * leftBankSp + paddingLeft;
    this.xRightBank = this.xP * rightBankSp + paddingLeft;
  } else {
    // 標高一覧を取得
    var riverWidth = cross.rvrwid;
    var surInterval = 1;
    var points = cross.points;
    // 隙間ができないように水位ポリゴンの描画位置を天端高の+-1に変更
    // var leftBank = points[leftBankIdx].distance * surInterval;
    // var rightBank = points[rightBankIdx].distance * surInterval;
    var leftBank = points[leftBankIdx].distance * surInterval;
    var rightBank = points[rightBankIdx + 1].distance * surInterval;

    if (cross.pointsOutBank && cross.pointsOutBank.length > 0) {
      // 堤外地の最右の描画幅（堤外地の幅）
      var sur = cross.pointsOutBank[cross.pointsOutBank.length - 1].drawLength;
      // 川幅を堤外地幅で割って描画インターバルとする
      surInterval = riverWidth / sur;
      rightBank = leftBank + (sur * surInterval) / 1000;
    }
    this.xLeftBank = this.xP * leftBank + paddingLeft;
    this.xRightBank = this.xP * rightBank + paddingLeft;
  }

  // 最新観測値を取得
  let lastStage = 0;
  let lastStg = 0;
  if (this.history < cross.stages.length) {
    lastStage = cross.stages[cross.stages.length - this.history - 1].elevation;
    lastStg = cross.stages[cross.stages.length - this.history - 1].stg;
    if (lastStage == null || isNaN(lastStage)) {
      // 水位がない場合は、欠測の文言表示する
      this.labelStage = cross.allStageNullMes;
      // 水位の標高の座標nullを設定
      this.yLabelStage = null;
      // 水位のEL値を非表示とする
      this.labelElStage = "";
      // 水位ポリゴンを空で作成
      var polygonStage = document.createElement("polygon");
      polygonStage.setAttribute("id", "poly_stage");
      var p = "0,0 0,0 0,0 0,0";
      polygonStage.setAttribute("points", p);
      polygonStage.setAttribute("class", this.stageFillClass);
      return polygonStage;
    }
    // 超過判定に応じて着色する
    if (this.stgMode === "0") {
      if (
        this.isFldStg &&
        lastStage >=
          tmObs.formatFloat(
            Math.round(
              (cross.levelValue.stageLvl5.stg + cross.zeroHighFix) * 100
            ) / 100,
            2
          )
      ) {
        // 堤防天端高を超える水位も描画可能とする
        this.stageFillClass = "cross-fill-stage-lv5";
      } else if (
        this.isLv4 &&
        lastStage >=
          tmObs.formatFloat(
            Math.round(
              (cross.levelValue.stageLvl4.stg + cross.zeroHighFix) * 100
            ) / 100,
            2
          )
      ) {
        this.stageFillClass = "cross-fill-stage-lv4";
      } else if (
        this.isLv3 &&
        lastStage >=
          tmObs.formatFloat(
            Math.round(
              (cross.levelValue.stageLvl3.stg + cross.zeroHighFix) * 100
            ) / 100,
            2
          )
      ) {
        this.stageFillClass = "cross-fill-stage-lv3";
      } else if (
        this.isLv2 &&
        lastStage >=
          tmObs.formatFloat(
            Math.round(
              (cross.levelValue.stageLvl2.stg + cross.zeroHighFix) * 100
            ) / 100,
            2
          )
      ) {
        this.stageFillClass = "cross-fill-stage-lv2";
      } else if (
        this.isLv1 &&
        lastStage >=
          tmObs.formatFloat(
            Math.round(
              (cross.levelValue.stageLvl1.stg + cross.zeroHighFix) * 100
            ) / 100,
            2
          )
      ) {
        this.stageFillClass = "cross-fill-stage-lv1";
      } else {
        this.stageFillClass = "cross-fill-stage";
      }
    } else {
      if (this.isFldStg && lastStage >= cross.levelValue.stageLvl5.value) {
        // 堤防天端高を超える水位も描画可能とする
        this.stageFillClass = "cross-fill-stage-lv5";
      } else if (this.isLv4 && lastStage >= cross.levelValue.stageLvl4.value) {
        this.stageFillClass = "cross-fill-stage-lv4";
      } else if (this.isLv3 && lastStage >= cross.levelValue.stageLvl3.value) {
        this.stageFillClass = "cross-fill-stage-lv3";
      } else if (this.isLv2 && lastStage >= cross.levelValue.stageLvl2.value) {
        this.stageFillClass = "cross-fill-stage-lv2";
      } else if (this.isLv1 && lastStage >= cross.levelValue.stageLvl1.value) {
        this.stageFillClass = "cross-fill-stage-lv1";
      } else {
        this.stageFillClass = "cross-fill-stage";
      }
    }
  } else {
    var idx =
      cross.stagesPrediction.length - (this.history - cross.stages.length) - 1;
    lastStage = cross.stagesPrediction[idx].elevation;
    lastStg = cross.stagesPrediction[idx].stg;
    this.stageFillClass = "cross-fill-prediction";
  }

  // 横断図上に表示する水位ラベルを設定
  if (this.stgMode === "0") {
    this.labelStage =
      this.cross.obsLabelZeroHigh +
      " " +
      tmObs.formatFloat(Math.round(lastStg * 100) / 100, 2) +
      "m";
  } else {
    this.labelStage =
      this.cross.obsLabel +
      " " +
      tmObs.formatFloat(Math.round((lastStage - cross.upgate) * 100) / 100, 2) +
      "m";
  }

  var height =
    this.viewBoxHeight - this.yP * (lastStage - this.min) - this.lowHeight;

  // 水位の標高を保持
  this.yLabelElStage = height;
  this.labelElStage = "(EL=" + Math.round(lastStage * 100) / 100 + "m)";

  let maxHeight = this.viewBoxHeight;

  let result;
  // 水位の塗りつぶしポリゴンを生成
  if (this.isFldStg && lastStage >= cross.levelValue.stageLvl5.value) {
    let pointLeftDis = this.cross.points[this.cross.leftBankIdx].distance;
    let pointRightDis = this.cross.points[this.cross.rightBankIdx].distance;

    if (
      this.cross.drawType != 2 &&
      this.leftOutBankIdx &&
      this.rightOutBankIdx
    ) {
      let outLeftDis = this.cross.pointsOutBank[this.leftOutBankIdx].drawLength;
      let outRightDis = this.cross.pointsOutBank[this.rightOutBankIdx]
        .drawLength;

      let sur = outRightDis - outLeftDis;
      let surInterval = this.cross.rvrwid / sur;
      let drawLength = (sur / 1000) * surInterval;
      this.adjusted = pointLeftDis + drawLength - pointRightDis;

      let points = this.cross.points;
      let xLabelElA = this.xP * points[0].distance + paddingLeft;
      let xLabelElB =
        this.xP * (points[points.length - 1].distance + this.adjusted) +
        paddingLeft;
      result = xLabelElA + "," + height;
      result += " " + xLabelElB + "," + height;
      result += " " + xLabelElB + "," + maxHeight;
      result += " " + xLabelElA + "," + maxHeight;
    } else {
      result = paddingLeft + "," + height;
      result += " " + (this.viewBoxWidth - paddingRight) + "," + height;
      result += " " + (this.viewBoxWidth - paddingRight) + "," + maxHeight;
      result += " " + paddingLeft + "," + maxHeight;
    }
  } else {
    result = this.xLeftBank + "," + height;
    result += " " + this.xRightBank + "," + height;
    result += " " + this.xRightBank + "," + maxHeight;
    result += " " + this.xLeftBank + "," + maxHeight;
  }

  var polygon = document.createElement("polygon");
  polygon.setAttribute("id", "poly_stage");
  polygon.setAttribute("points", result);
  polygon.setAttribute("class", this.stageFillClass);

  return polygon;
};

/**
 * 標高ポリゴンを生成
 */
DrawCross.prototype.getPointsPolygon = function() {
  var values = [];
  var cross = this.cross;

  // 標高一覧を取得
  var points = cross.points;

  // 左右岸のインデックスを取得
  var leftBankIdx = cross.leftBankIdx;
  var rightBankIdx = cross.rightBankIdx;

  // 川幅
  var riverWidth = cross.rvrwid;
  var surInterval = 0;
  if (cross.pointsOutBank && cross.pointsOutBank.length > 0) {
    // 堤外地の描画幅
    var sur =
      cross.pointsOutBank[this.rightOutBankIdx].drawLength -
      cross.pointsOutBank[this.leftOutBankIdx].drawLength;
    // 川幅を堤外地幅で割って描画インターバルとする
    surInterval = riverWidth / sur;
  }

  var x1, x2, y2;
  var beforeX1 = paddingLeft;

  // 補正値
  this.adjusted = 0;
  let cutEnd = null;

  // 標高データの件数分ループ
  for (var index = 0; index < this.maxPointsIdx; index++) {
    // 堤外地の描画 ===================================================================
    // if (
    //   index >= leftBankIdx &&
    //   index <= rightBankIdx &&
    //   cross.sfLeftLimit != null &&
    //   cross.sfRightLimit != null
    // ) {
    if (index >= leftBankIdx && index <= rightBankIdx) {
      // 横断データ・左右岸限界点座標がある場合、横断データから描画
      // if (surInterval > 0) {
      if (
        surInterval > 0 &&
        cross.sfLeftLimit != null &&
        cross.sfRightLimit != null
      ) {
        var distance = points[index].distance;
        var startLength = cross.pointsOutBank[this.leftOutBankIdx].drawLength;
        var drawLength = 0;
        // 横断データの件数分ループ
        for (var idx in cross.pointsOutBank) {
          var p = cross.pointsOutBank[idx];
          if (isEmpty(p.drawLength) || isEmpty(p.drawHeight)) continue;

          var height = p.drawHeight;

          // 縦位置確認ライン
          if (isEmpty(height)) continue;

          // 限界点が指定されている場合
          if (cross.sfLeftLimit != null && cross.sfRightLimit != null) {
            if (
              p.drawLength < cross.sfLeftLimit ||
              p.drawLength > cross.sfRightLimit
            ) {
              continue;
            }
          }

          drawLength = ((p.drawLength - startLength) / 1000) * surInterval;
          var val = height - this.min;

          x1 = beforeX1;
          x2 = this.xP * (distance + drawLength) + paddingLeft;
          y2 = this.viewBoxHeight - this.yP * val - this.lowHeight;

          beforeX1 = x2;

          var valIn = {
            class: "cross-fill-normal",
            x1: x1,
            x2: x2,
            y2: y2,
          };
          values.push(valIn);
        }
        index = rightBankIdx;
        // 堤外地は描画比率が違うため、補正する
        this.adjusted = distance + drawLength - points[index].distance;
      } else {
        x1 = beforeX1;
        x2 = this.xP * points[index].distance + paddingLeft;
        beforeX1 = x2;

        // y2 = this.viewBoxHeight;

        if (points[index].h < this.min && cutEnd === null) {
          cutEnd = getEndIdx(points, leftBankIdx, rightBankIdx, this.min);
        }

        if (cutEnd != null && (cutEnd >= index || cutEnd === index)) {
          y2 = this.viewBoxHeight;
        } else {
          var h2 = this.viewBoxHeight;
          if (points[index].h) {
            h2 = points[index].h - this.min;
          }
          y2 = this.viewBoxHeight - this.yP * h2 - this.lowHeight;
        }

        var valF = {
          class: "cross-fill-normal",
          x1: x1,
          x2: x2,
          y2: y2,
        };
        values.push(valF);
      }
      continue;
    }
    // 堤内地の描画 ===================================================================
    else {
      x1 = beforeX1;
      x2 = this.xP * (points[index].distance + this.adjusted) + paddingLeft;
      beforeX1 = x2;

      if (points[index].h < this.min) {
        y2 = this.viewBoxHeight;
      } else {
        y2 =
          this.viewBoxHeight -
          this.yP * (points[index].h - this.min) -
          this.lowHeight;
      }

      var valOut = {
        class: "cross-fill-normal",
        x1: x1,
        x2: x2,
        y2: y2,
      };
      values.push(valOut);
    }
  }

  // polygon用に返却値を作成
  // 予め底辺の2点を設定

  // var underHeight = this.viewBoxHeight - this.lowHeight;
  var underHeight = this.viewBoxHeight;
  var result = values[values.length - 1].x2 + "," + underHeight;
  result += " " + values[0].x2 + "," + underHeight;
  // データ件数分 x,y を設定
  for (var i = 0; i < values.length; i++) {
    result += " " + values[i].x2 + "," + values[i].y2;
  }

  var polygon = document.createElement("polygon");
  polygon.setAttribute("points", result);
  polygon.setAttribute("class", "cross-fill-normal");

  return polygon;
};

/**
 * 特殊横断 標高ポリゴンを生成
 */
DrawCross.prototype.getPointsPolygonSp = function() {
  var values = [];
  var cross = this.cross;
  // 横断データの左端を取得
  var leftLength = cross.pointsOutBank[0].drawLength;

  var x1, x2, y2;
  var beforeX1 = paddingLeft;

  // 横断データの件数分ループ
  for (var idx in cross.pointsOutBank) {
    var p = cross.pointsOutBank[idx];
    if (isEmpty(p.drawLength) || isEmpty(p.drawHeight)) continue;

    var drawLength = p.drawLength - leftLength;
    var height = p.drawHeight;

    // 縦位置確認ライン
    if (isEmpty(height)) continue;

    // 特殊横断の場合は限界点外も描画する
    // if (cross.sfLeftLimit != null && cross.sfRightLimit) {
    //   if (
    //     p.drawLength < cross.sfLeftLimit ||
    //     p.drawLength > cross.sfRightLimit
    //   ) {
    //     continue;
    //   }
    // }

    var val = height - this.min;
    x1 = beforeX1;
    x2 = this.xP * drawLength + paddingLeft;
    y2 = this.viewBoxHeight - this.yP * val - this.lowHeight;
    beforeX1 = x2;

    var valIn = {
      class: "cross-fill-normal",
      x1: x1,
      x2: x2,
      y2: y2,
    };

    values.push(valIn);
  }

  // polygon用に返却値を作成
  // 予め底辺の2点を設定

  // var underHeight = this.viewBoxHeight - this.lowHeight;
  var underHeight = this.viewBoxHeight;
  var result = values[values.length - 1].x2 + "," + underHeight;
  result += " " + values[0].x2 + "," + underHeight;
  // データ件数分 x,y を設定
  for (var i = 0; i < values.length; i++) {
    result += " " + values[i].x2 + "," + values[i].y2;
  }

  var polygon = document.createElement("polygon");
  polygon.setAttribute("points", result);
  polygon.setAttribute("class", "cross-fill-normal");

  return polygon;
};

/**
 * 標高ラインを生成
 */
DrawCross.prototype.getPointsLine = function() {
  var values = [];
  var cross = this.cross;

  var x1, x2, y1, y2;
  var beforeY1 = 0;
  var beforeX1 = paddingLeft;

  var leftBankIdx = cross.leftBankIdx;
  var rightBankIdx = cross.rightBankIdx;

  // 標高一覧を取得
  var points = cross.points;

  // A地点のELテキスト・x,y座標を設定
  this.labelElA = "(EL=" + Math.round(points[0].h * 100) / 100 + "m)";
  this.xLabelElA = this.xP * points[this.cross.AIdx].distance + paddingLeft;
  this.yLabelElA =
    this.viewBoxHeight -
    this.yP * (points[this.cross.AIdx].h - this.min) -
    this.lowHeight;

  // B地点のELテキスト・x,y座標を設定
  this.labelElB =
    "(EL=" + Math.round(points[this.cross.BIdx].h * 100) / 100 + "m)";
  this.xLabelElB =
    this.xP * (points[this.cross.BIdx].distance + this.adjusted) + paddingLeft;
  this.yLabelElB =
    this.viewBoxHeight -
    this.yP * (points[this.cross.BIdx].h - this.min) -
    this.lowHeight;

  // 現在地点のELテキスト・x,y座標を設定
  if (cross.isDispPresent) {
    var pIdx;
    if (cross.isPresentOut) {
      if (cross.dispP === 1) {
        pIdx = 0;
      } else {
        pIdx = points.length - 1;
      }
    } else {
      pIdx = cross.nearIndex;
    }
    this.labelElParent = "(EL=" + Math.round(points[pIdx].h * 100) / 100 + "m)";

    if (pIdx < 50) {
      this.dxLabelElParent = 20;
    } else {
      var dx = this.labelElParent.length * -18;
      this.dxLabelElParent = dx;
    }

    if (pIdx == 0) {
      this.xLabelElParent = this.xP * points[pIdx].distance + paddingLeft;
    } else {
      this.xLabelElParent =
        this.xP * (points[pIdx].distance + this.adjusted) + paddingLeft;
    }

    this.yLabelElParent =
      this.viewBoxHeight -
      this.yP * (points[pIdx].h - this.min) -
      this.lowHeight;

    if (cross.dispP == 1 || cross.dispP == 3) {
      this.xLineEnd = this.xLabelElB;
      this.yLineEnd = this.yLabelElB;
    } else {
      this.xLineEnd = this.xLabelElParent;
      this.yLineEnd = this.yLabelElParent;
    }
  } else {
    this.xLineEnd = this.xLabelElB;
    this.yLineEnd = this.yLabelElB;
  }

  // 川幅
  var riverWidth = cross.rvrwid;
  var surInterval = 0;
  if (cross.pointsOutBank && cross.pointsOutBank.length > 0) {
    // 堤外地の描画幅
    var sur =
      cross.pointsOutBank[this.rightOutBankIdx].drawLength -
      cross.pointsOutBank[this.leftOutBankIdx].drawLength;
    // 川幅を堤外地幅で割って描画インターバルとする
    surInterval = riverWidth / sur;
  }

  // 川幅の中央を堤防天端高からの表示のために保持
  var centerLength = riverWidth / 1000 / 2;
  var leftBlankDistance = points[leftBankIdx].distance;

  this.xLabelStage = this.xP * (leftBlankDistance + centerLength) + paddingLeft;

  // 補正値
  this.adjusted = 0;
  let cutEnd = null;

  for (var index = 1; index < this.maxPointsIdx; index++) {
    let strClass = "cross-line-normal";
    // 堤外地の描画 ===================================================================
    if (index >= leftBankIdx && index <= rightBankIdx) {
      // 横断データ・左右岸限界点座標がある場合、横断データから描画
      if (
        surInterval > 0 &&
        cross.sfLeftLimit != null &&
        cross.sfRightLimit != null
      ) {
        var distance = points[index].distance;
        var startLength = cross.pointsOutBank[this.leftOutBankIdx].drawLength;
        var drawLength = 0;
        // 横断データの件数分ループ
        for (var idx2 in cross.pointsOutBank) {
          var p = cross.pointsOutBank[idx2];
          if (isEmpty(p.drawLength) || isEmpty(p.drawHeight)) continue;

          var height = p.drawHeight;

          // 縦位置確認ライン
          if (isEmpty(height)) continue;

          // 限界点が指定されている場合
          if (cross.sfLeftLimit != null && cross.sfRightLimit != null) {
            if (
              p.drawLength < cross.sfLeftLimit ||
              p.drawLength > cross.sfRightLimit
            ) {
              continue;
            }
          }

          drawLength = ((p.drawLength - startLength) / 1000) * surInterval;
          var val = height - this.min;

          x1 = beforeX1;
          x2 = this.xP * (distance + drawLength) + paddingLeft;
          y1 = beforeY1;
          y2 = this.viewBoxHeight - this.yP * val - this.lowHeight;
          beforeX1 = x2;
          beforeY1 = y2;

          var val2 = {
            class: strClass,
            x1: x1,
            x2: x2,
            y1: y1,
            y2: y2,
          };
          values.push(val2);
          strClass = "cross-line-out-blank";
        }
        index = rightBankIdx;
        // 堤外地は描画比率が違うため、補正する
        this.adjusted = distance + drawLength - points[index].distance;
      } else {
        x1 = beforeX1;
        x2 = this.xP * points[index].distance + paddingLeft;
        beforeX1 = x2;

        if (points[index].h < this.min && cutEnd === null) {
          cutEnd = getEndIdx(points, leftBankIdx, rightBankIdx, this.min);
        }

        y2 = this.viewBoxHeight;
        if (cutEnd != null && (cutEnd >= index || cutEnd === index)) {
          y2 = this.viewBoxHeight;
        } else {
          var h2 = this.viewBoxHeight;
          if (points[index].h) {
            h2 = points[index].h - this.min;
          }
          y2 = this.viewBoxHeight - this.yP * h2 - this.lowHeight;
        }

        if (beforeY1 == 0) {
          y1 = y2;
        } else {
          y1 = beforeY1;
        }
        beforeY1 = y2;
        var value = {
          class: strClass,
          x1: x1,
          x2: x2,
          y1: y1,
          y2: y2,
        };
        values.push(value);
        strClass = "cross-line-out-blank";
      }
      continue;
    }
    // 堤内地の描画 ===================================================================
    else {
      // 堤内地の描画
      strClass = "cross-line-normal";
      x1 = beforeX1;
      x2 = this.xP * (points[index].distance + this.adjusted) + paddingLeft;
      beforeX1 = x2;

      if (points[index].h < this.min) {
        y2 = this.viewBoxHeight;
      } else {
        y2 =
          this.viewBoxHeight -
          this.yP * (points[index].h - this.min) -
          this.lowHeight;
      }

      if (beforeY1 == 0) {
        y1 = y2;
      } else {
        y1 = beforeY1;
      }
      beforeY1 = y2;

      if (cross.dispP === 1) {
        if (index <= cross.AIdx) {
          strClass = "cross-line-parent";
        }
      } else if (cross.dispP === 2) {
        if (index >= cross.BIdx) {
          strClass = "cross-line-parent";
        }
      }
    }

    var valP = {
      class: strClass,
      x1: x1,
      x2: x2,
      y1: y1,
      y2: y2,
    };
    values.push(valP);
  }

  return values;
};

/**
 * 特殊横断 標高ラインを生成
 */
DrawCross.prototype.getPointsLineSp = function() {
  var values = [];
  var cross = this.cross;

  // 横断データの左端を取得
  var leftLength = cross.pointsOutBank[0].drawLength;
  var rightLength =
    cross.pointsOutBank[cross.pointsOutBank.length - 1].drawLength;
  var rightHeight =
    cross.pointsOutBank[cross.pointsOutBank.length - 1].drawHeight;

  this.xLabelElB = this.xP * (rightLength - leftLength) + paddingLeft;
  this.yLabelElB =
    this.viewBoxHeight - this.yP * (rightHeight - this.min) - this.lowHeight;

  var x1, x2, y1, y2;
  var beforeY1 = 0;
  var beforeX1 = paddingLeft;

  this.xLineEnd = this.xLabelElB;
  this.yLineEnd = this.yLabelElB;

  // 川幅
  var riverWidth = rightLength - leftLength;
  // 川幅の中央を堤防天端高からの表示のために保持
  var centerLength = riverWidth / 2;

  this.xLabelStage = this.xP * centerLength + paddingLeft;

  // 横断データの件数分ループ
  for (var idx2 in cross.pointsOutBank) {
    var p = cross.pointsOutBank[idx2];
    if (isEmpty(p.drawLength) || isEmpty(p.drawHeight)) continue;

    var drawLength = p.drawLength - leftLength;
    var height = p.drawHeight;

    // 縦位置確認ライン
    if (isEmpty(height)) continue;

    // 特殊横断の場合は限界点外も描画する
    // 限界点が指定されている場合
    // if (cross.sfLeftLimit != null && cross.sfRightLimit != null) {
    //   if (
    //     p.drawLength < cross.sfLeftLimit ||
    //     p.drawLength > cross.sfRightLimit
    //   ) {
    //     continue;
    //   }
    // }

    var val = height - this.min;

    x1 = beforeX1;
    x2 = this.xP * drawLength + paddingLeft;
    y1 = beforeY1;
    y2 = this.viewBoxHeight - this.yP * val - this.lowHeight;
    beforeX1 = x2;
    beforeY1 = y2;

    var val2 = {
      class: "cross-line-out-blank",
      x1: x1,
      x2: x2,
      y1: y1,
      y2: y2,
    };
    values.push(val2);
  }

  return values;
};

/**
 * マーカー位置に縦ラインを描画
 */
DrawCross.prototype.getVerticalLine = function() {
  var values = [];

  // A点に縦ラインを描画
  var valA = {
    x1: this.xLabelElA,
    y1: this.viewBoxHeight - this.lowHeight,
    x2: this.xLabelElA,
    y2: this.yLabelElA,
    class: "cross-point",
  };
  values.push(valA);

  // B点に縦ラインを描画
  var valB = {
    x1: this.xLabelElB,
    y1: this.viewBoxHeight - this.lowHeight,
    x2: this.xLabelElB,
    y2: this.yLabelElB,
    class: "cross-point",
  };
  values.push(valB);

  // 現在地描画ありで、現在地がA・B点より外側にある場合、現在地点に縦ラインを描画
  if (this.cross.isDispPresent && this.cross.isPresentOut) {
    var valP = {
      x1: this.xLabelElParent,
      y1: this.viewBoxHeight - this.lowHeight,
      x2: this.xLabelElParent,
      y2: this.yLabelElParent,
      class: "cross-point",
    };
    values.push(valP);
  }

  return values;
};

/**
 * 基準値ラインを描画
 */
DrawCross.prototype.getLevelLine = function() {
  let values = [];
  let cross = this.cross;
  let x2, y1, y2;

  let labelArray = Object.keys(cross.levelValue);
  let isLvs = [this.isLv1, this.isLv2, this.isLv3, this.isLv4, true];
  x2 = this.xLineEnd;

  this.yStandard = [];

  // 基準値の線を描画
  for (let i = 0; i <= labelArray.length - 1; i++) {
    let label = labelArray[i];
    let level = cross.levelValue[label];
    if (isLvs[i]) {
      if (!this.isFldStg) {
        // 氾濫開始水位が無い場合は、堤防天端からの高さが未設定なので値を算出
        y1 =
          this.viewBoxHeight -
          this.yP * (level.stg + this.cross.zeroHighFix - this.min) -
          this.lowHeight;
      } else {
        y1 =
          this.viewBoxHeight -
          this.yP * (level.value - this.min) -
          this.lowHeight;
      }

      y2 = y1;

      let strClass = "cross-stroke-leve-";
      let val = {
        class: strClass + label,
        x1: paddingLeft,
        x2: x2,
        y1: y1,
        y2: y2,
      };
      values.push(val);
    }

    // 基準値のy座標を配列に保持
    this.yStandard.push(y1);
  }

  // 零点高の線を描画
  if (this.stgMode === "0" && cross.zeroHighFix != null && this.isZeroLine) {
    y1 =
      this.viewBoxHeight -
      this.yP * (cross.zeroHighFix - this.min) -
      this.lowHeight;
    y2 = y1;
    let val = {
      class: "cross-stroke-zero",
      x1: paddingLeft,
      x2: x2,
      y1: y1,
      y2: y2,
    };
    values.push(val);
    this.yZero = y1;
  } else {
    this.yZero = this.viewBoxHeight - this.lowHeight;
  }
  // 最新観測値を取得
  let lastStage = 0;
  if (this.history < cross.stages.length) {
    lastStage = cross.stages[cross.stages.length - this.history - 1].elevation;
  } else {
    let idx =
      cross.stagesPrediction.length - (this.history - cross.stages.length) - 1;
    lastStage = cross.stagesPrediction[idx].elevation;
  }

  let valStageClass = "";
  let height = 0;
  if (lastStage == null || isNaN(lastStage)) {
    // ラベル表示用の高さにnullを保持
    this.yLabelStage = null;
    // 線を非表示とする
    valStageClass = "cross-line-none";
  } else {
    height =
      this.viewBoxHeight - this.yP * (lastStage - this.min) - this.lowHeight;
    // ラベル表示用の高さを保持
    this.yLabelStage = height;
    // 水位の線を描画
    valStageClass = "cross-stage";
  }

  // 水位に点線を表示
  let valStage = {
    id: "line_stage",
    class: valStageClass,
    x1: paddingLeft,
    x2: x2,
    y1: height,
    y2: height,
  };
  values.push(valStage);

  if (cross.isDispPresent && !cross.isPresentOut) {
    let pre = cross.points[cross.nearIndex].h;
    let hPre = this.viewBoxHeight - this.yP * (pre - this.min) - this.lowHeight;

    let valPresent = {
      class: "cross-stroke-present",
      x1: paddingLeft,
      x2: x2,
      y1: hPre,
      y2: hPre,
    };

    values.push(valPresent);
  }
  return values;
};

/**
 * スケールラインを描画
 */
DrawCross.prototype.getScaleLine = function() {
  var values = [];
  var kilo = 1000;
  if (this.cross.drawType == 2) {
    kilo = 1;
  }

  this.scale = 25;
  if (this.cross.rvrwid >= 100) {
    this.scale = 100;
  } else if (this.cross.rvrwid >= 50) {
    this.scale = 50;
  } else if (this.cross.rvrwid >= 25) {
    this.scale = 25;
  } else {
    this.scale = 5;
  }

  if (!this.scrollMode) {
    this.legendScroll = 35;
  }

  // ラベルを設定
  this.labelScale = this.scale + "m";
  // 横の線を描画
  var valStage = {
    class: "cross-scale-line",
    x1: this.legendScroll + xScale,
    y1: 40,
    x2: (this.scale / kilo) * this.xP + this.legendScroll + xScale,
    y2: 40,
  };
  values.push(valStage);
  // 左の縦線を描画
  valStage = {
    class: "cross-scale-line",
    x1: this.legendScroll + xScale,
    y1: 30,
    x2: this.legendScroll + xScale,
    y2: 50,
  };
  values.push(valStage);
  // 右の縦線を描画
  valStage = {
    class: "cross-scale-line",
    x1: (this.scale / kilo) * this.xP + this.legendScroll + xScale,
    y1: 30,
    x2: (this.scale / kilo) * this.xP + this.legendScroll + xScale,
    y2: 50,
  };
  values.push(valStage);

  return values;
};

/**
 * マーカーを描画
 */
DrawCross.prototype.getMarkers = function() {
  var values = [];

  // A点マーカー描画
  var imgA = {
    x: this.xLabelElA - 20,
    y: this.viewBoxHeight - this.lowHeight - 50,
    width: "40px",
    xlinkhref: this.cross.point.a,
  };
  values.push(imgA);

  // B点マーカー描画
  var imgB = {
    x: this.xLabelElB - 20,
    y: this.viewBoxHeight - this.lowHeight - 50,
    width: "40px",
    xlinkhref: this.cross.point.b,
  };
  values.push(imgB);

  // 現在地マーカー描画
  if (this.cross.isDispPresent) {
    var imgP = {
      x: this.xLabelElParent - 24,
      y: this.yLabelElParent - 48,
      width: "48px",
      xlinkhref: this.cross.point.p,
    };
    values.push(imgP);
  }
  return values;
};

/**
 * 水位までのラインを描画
 */
DrawCross.prototype.getStageLine = function() {
  var values = [];
  var valClass = "";
  var y1 = 0;
  if (this.yLabelStage == null) {
    valClass = "cross-line-none";
  } else {
    valClass = "cross-stage-center";
    y1 = this.yLabelStage;
  }

  var val = {
    id: "line_stage_v",
    x1: this.xLabelStage,
    y1: y1,
    x2: this.xLabelStage,
    y2: 120,
    class: valClass,
  };
  values.push(val);
  return values;
};

/**
 * スケールのラベルを描画
 */
DrawCross.prototype.getScaleText = function() {
  var values = [];
  var val = {
    x: this.legendScroll + xScale,
    y: 20,
    dx: 0,
    class: "label",
    label: this.labelScale,
  };
  values.push(val);
  return values;
};

/**
 * 凡例の外枠を描画
 */
DrawCross.prototype.getLegendRect = function() {
  // let height = legendHeight;
  // if (this.cross.sys === "sw") {
  //   if (this.mode === "mb") {
  //     height = legendHeightSwMb;
  //   } else {
  //     height = legendHeightSw;
  //   }
  // } else {
  //   if (this.mode === "mb") {
  //     height = legendHeightMb;
  //   } else {
  //     height = legendHeight;
  //   }
  // }
  let height = this.legendRectHeight;
  let val = {
    id: "rect_legend",
    x: this.legendScroll + this.xLegend,
    y: yLegend,
    width: legendWidth,
    height: height,
    class: "legend",
  };
  return val;
};

/**
 * 凡例テキスト（通常水位）を描画
 */
DrawCross.prototype.getLegendText = function() {
  let interval = 70;
  let legendH = 25;
  let exH = 55;
  let yValue = 300;
  let legendMargen = this.legendLetMargin;
  let legendMargenEx = this.legendLetMargin;
  let strClassLegend = "legend-text";
  let strClassEx = "legend-explanation";
  let strClassMsg = "legend-message";
  if (this.mode === "mb") {
    interval = 30;
    legendH = 20;
    exH = 20;
    legendMargenEx += 120;
    yValue = 410;
    strClassLegend = "legend-text-mb";
    strClassEx = "legend-explanation-mb";
    strClassMsg = "legend-message-mb";
  }

  let values = [];

  if (this.isFldStg) {
    let val5 = {
      x: this.legendScroll + this.xLegend + legendMargen,
      y: yLegend + legendH,
      dx: 0,
      class: strClassLegend + " legend-lv-5",
      label: "堤防天端",
    };
    if (this.stgMode === "0") {
      val5.label = this.cross.levelValue.stageLvl5.label;
    }
    values.push(val5);
    legendH += interval;
  }

  let val4 = {
    x: this.legendScroll + this.xLegend + legendMargen,
    y: yLegend + legendH,
    dx: 0,
    class: strClassLegend + " legend-lv-4",
    label: "氾濫危険水位",
  };
  values.push(val4);

  legendH += interval;
  let val3 = {
    x: this.legendScroll + this.xLegend + legendMargen,
    y: yLegend + legendH,
    dx: 0,
    class: strClassLegend + " legend-lv-3",
    label: "避難判断水位",
  };
  values.push(val3);

  legendH += interval;
  let val2 = {
    x: this.legendScroll + this.xLegend + legendMargen,
    y: yLegend + legendH,
    dx: 0,
    class: strClassLegend + " legend-lv-2",
    label: "氾濫注意水位",
  };
  values.push(val2);

  if (this.isFldCtl) {
    legendH += interval;
    let val1 = {
      x: this.legendScroll + this.xLegend + legendMargen,
      y: yLegend + legendH,
      dx: 0,
      class: strClassLegend + " legend-lv-1",
      label: "水防団待機水位",
    };
    values.push(val1);
  }

  if (this.isFldStg) {
    let ex5 = {
      x: this.legendScroll + this.xLegend + legendMargenEx,
      y: yLegend + exH,
      dx: 5,
      dy: -4,
      class: strClassEx,
      label: "氾濫が発生する水位",
    };
    values.push(ex5);
    exH += interval;
  }
  let ex4 = {
    x: this.legendScroll + this.xLegend + legendMargenEx,
    y: yLegend + exH,
    dx: 5,
    dy: -4,
    class: strClassEx,
    label: "河川が氾濫する恐れがある水位",
  };
  values.push(ex4);

  exH += interval;
  let ex3 = {
    x: this.legendScroll + this.xLegend + legendMargenEx,
    y: yLegend + exH,
    dx: 5,
    dy: -4,
    class: strClassEx,
    label: "避難情報発表の目安となる水位",
  };
  values.push(ex3);

  exH += interval;
  let ex2Label = "河川の氾濫の発生を注意する水位";
  if (this.isFldCtl) {
    ex2Label = "水防団が出動する目安となる水位";
  }

  let ex2 = {
    x: this.legendScroll + this.xLegend + legendMargenEx,
    y: yLegend + exH,
    dx: 5,
    dy: -4,
    class: strClassEx,
    label: ex2Label,
  };
  values.push(ex2);

  if (this.isFldCtl) {
    exH += interval;
    let ex1 = {
      x: this.legendScroll + this.xLegend + legendMargenEx,
      y: yLegend + exH,
      dx: 5,
      dy: -4,
      class: strClassEx,
      label: "水防団が待機する目安となる水位",
    };
    values.push(ex1);
  }
  if (this.stgMode !== "0") {
    exH += 25;
    let msg = {
      x: this.legendScroll + this.xLegend,
      y: yLegend + exH,
      dx: 4,
      dy: 0,
      class: strClassMsg,
      label: "※基準水位の数字は、堤防天端からの距離です",
    };
    values.push(msg);
  }

  let upgate = this.cross.levelValue.stageLvl5.value;
  if (this.mode === "mb") {
    legendH = 20;
  } else {
    legendH = 25;
  }

  if (this.isFldStg) {
    let lblLv5 = "0m";
    if (this.stgMode === "0") {
      lblLv5 =
        Math.round(this.cross.levelValue.stageLvl5.stg * 100) / 100 + "m";
    }
    let lVal5 = {
      x: this.legendScroll + this.xLegend + yValue,
      y: yLegend + legendH,
      dx: 0,
      class: strClassLegend + " legend-lv-5",
      label: lblLv5,
    };
    values.push(lVal5);
    legendH += interval;
  }

  let lblLv4 = "―";
  if (this.isLv4) {
    let valLv4 = 0;
    if (this.stgMode === "0") {
      valLv4 = this.cross.levelValue.stageLvl4.stg;
    } else {
      valLv4 = this.cross.levelValue.stageLvl4.value - upgate;
    }
    lblLv4 = Math.round(valLv4 * 100) / 100 + "m";
  }

  let lVal4 = {
    x: this.legendScroll + this.xLegend + yValue,
    y: yLegend + legendH,
    dx: 0,
    class: strClassLegend + " legend-lv-4",
    label: lblLv4,
  };
  values.push(lVal4);

  legendH += interval;
  let lblLv3 = "―";
  if (this.isLv3) {
    let valLv3 = 0;
    if (this.stgMode === "0") {
      valLv3 = this.cross.levelValue.stageLvl3.stg;
    } else {
      valLv3 = this.cross.levelValue.stageLvl3.value - upgate;
    }
    lblLv3 = Math.round(valLv3 * 100) / 100 + "m";
  }
  let lVal3 = {
    x: this.legendScroll + this.xLegend + yValue,
    y: yLegend + legendH,
    dx: 0,
    class: strClassLegend + " legend-lv-3",
    label: lblLv3,
  };
  values.push(lVal3);

  legendH += interval;
  let lblLv2 = "―";
  if (this.isLv2) {
    let valLv2 = 0;
    if (this.stgMode === "0") {
      valLv2 = this.cross.levelValue.stageLvl2.stg;
    } else {
      valLv2 = this.cross.levelValue.stageLvl2.value - upgate;
    }
    lblLv2 = Math.round(valLv2 * 100) / 100 + "m";
  }
  let lVal2 = {
    x: this.legendScroll + this.xLegend + yValue,
    y: yLegend + legendH,
    dx: 0,
    class: strClassLegend + " legend-lv-2",
    label: lblLv2,
  };
  values.push(lVal2);

  legendH += interval;
  let lblLv1 = "―";
  if (this.isLv1) {
    let valLv1 = 0;
    if (this.stgMode === "0") {
      valLv1 = this.cross.levelValue.stageLvl1.stg;
    } else {
      valLv1 = this.cross.levelValue.stageLvl1.value - upgate;
    }
    lblLv1 = Math.round(valLv1 * 100) / 100 + "m";
  }
  let lVal1 = {
    x: this.legendScroll + this.xLegend + yValue,
    y: yLegend + legendH,
    dx: 0,
    class: strClassLegend + " legend-lv-1",
    label: lblLv1,
  };
  values.push(lVal1);
  this.legendRectHeight = yLegend + exH;
  return values;
};

/**
 * 凡例テキスト（危機管理型水位計）を描画
 */
DrawCross.prototype.getLegendTextSw = function() {
  let interval = 70;
  let legendH = 25;
  let exH = 55;
  let yValue = 300;
  let legendMargen = this.legendLetMargin;
  let legendMargenEx = this.legendLetMargin;
  let strClassLegend = "legend-text";
  let strClassEx = "legend-explanation";
  let strClassMsg = "legend-message";
  if (this.mode === "mb") {
    interval = 30;
    legendH = 20;
    exH = 20;
    legendMargenEx += 120;
    yValue = 410;
    strClassLegend = "legend-text-mb";
    strClassEx = "legend-explanation-mb";
    strClassMsg = "legend-message-mb";
  }
  let values = [];
  if (this.isFldStg) {
    var val5 = {
      x: this.legendScroll + this.xLegend + legendMargen,
      y: yLegend + legendH,
      dx: 0,
      class: strClassLegend + " legend-lv-5",
      label: "氾濫開始水位",
    };
    values.push(val5);
    legendH += interval;
  }

  if (this.mode === "mb") {
    legendH += interval;
  }

  var val4 = {
    x: this.legendScroll + this.xLegend + legendMargen,
    y: yLegend + legendH,
    dx: 0,
    class: strClassLegend + " legend-lv-4",
    label: "危険水位",
  };
  values.push(val4);

  legendH += interval;
  var val2 = {
    x: this.legendScroll + this.xLegend + legendMargen,
    y: yLegend + legendH,
    dx: 0,
    class: strClassLegend + " legend-lv-2",
    label: "観測開始水位",
  };
  values.push(val2);

  if (this.isFldStg) {
    var ex5 = {
      x: this.legendScroll + this.xLegend + legendMargenEx,
      y: yLegend + exH,
      dx: 5,
      dy: -4,
      class: strClassEx,
      label: "氾濫が発生する水位",
    };
    values.push(ex5);
    exH += interval;
  }

  if (this.mode === "mb") {
    exH += interval;
  }

  var ex4 = {
    x: this.legendScroll + this.xLegend + legendMargenEx,
    y: yLegend + exH,
    dx: 5,
    dy: -4,
    class: strClassEx,
    label: "河川が氾濫する恐れがある水位",
  };
  values.push(ex4);

  exH += interval;
  var ex2 = {
    x: this.legendScroll + this.xLegend + legendMargenEx,
    y: yLegend + exH,
    dx: 5,
    dy: -4,
    class: strClassEx,
    label: "短い間隔で観測を開始する水位",
  };
  values.push(ex2);

  exH += this.mode !== "mb" ? 35 : 25;
  var msg = {
    x: this.legendScroll + this.xLegend,
    y: yLegend + exH,
    dx: 4,
    dy: 0,
    class: strClassMsg,
    label: "※基準水位の数字は、堤防天端からの距離です。",
  };
  values.push(msg);

    exH += 25;
    const msg2_1 = "※横断図の箇所と氾濫開始水位等の設定箇所は、"
    const msg2_2 = "一般的に異なります。"
    var msg2 = {
      x: this.legendScroll + this.xLegend,
      y: yLegend + exH,
      dx: 4,
      dy: 0,
      class: strClassMsg,
      label: this.mode !== "mb" ? msg2_1 : msg2_1 + msg2_2,
    };
    values.push(msg2);
  
    if (this.mode !== "mb") {  
      exH += 25;
      var msg3 = {
        x: this.legendScroll + this.xLegend,
        y: yLegend + exH,
        dx: 4,
        dy: 0,
        class: strClassMsg,
        label: "　" + msg2_2,
      };
      values.push(msg3);
    }

  var upgate = this.cross.levelValue.stageLvl5.value;
  if (this.mode === "mb") {
    legendH = 20;
  } else {
    legendH = 25;
  }

  let lVal5;
  let dxM = 0;
  if (this.mode === "mb") {
    lVal5 = {
      x: this.legendScroll + this.xLegend + yValue,
      y: yLegend + legendH,
      dx: dxM,
      class: strClassLegend + " legend-lv-5",
      label: "0m",
    };
  } else {
    dxM = -55;
    lVal5 = {
      x: this.legendScroll + this.xLegend + yValue,
      y: yLegend + legendH,
      dx: dxM,
      class: strClassLegend + " legend-lv-5",
      label: "0m" + "(EL=" + this.cross.upgate + "m)",
    };
  }

  values.push(lVal5);

  if (this.mode === "mb") {
    legendH += interval;
    let lValEl = {
      x: this.legendScroll + this.xLegend + yValue,
      y: yLegend + legendH,
      dx: dxM - 40,
      class: strClassLegend + " legend-lv-5",
      label: "(EL=" + this.cross.upgate + "m)",
    };
    values.push(lValEl);
  }

  legendH += interval;
  var lblLv4 = "―";
  if (this.isLv4) {
    lblLv4 =
      Math.round((this.cross.levelValue.stageLvl4.value - upgate) * 100) / 100 +
      "m";
  }
  var lVal4 = {
    x: this.legendScroll + this.xLegend + yValue,
    y: yLegend + legendH,
    dx: dxM,
    class: strClassLegend + " legend-lv-4",
    label: lblLv4,
  };
  values.push(lVal4);

  legendH += interval;
  var lblLv2 = "―";
  if (this.isLv2) {
    lblLv2 =
      Math.round((this.cross.levelValue.stageLvl2.value - upgate) * 100) / 100 +
      "m";
  }
  var lVal2 = {
    x: this.legendScroll + this.xLegend + yValue,
    y: yLegend + legendH,
    dx: dxM,
    class: strClassLegend + " legend-lv-2",
    label: lblLv2,
  };
  values.push(lVal2);
  this.legendRectHeight = yLegend + exH;
  return values;
};

/**
 * 凡例ラインを描画
 */
DrawCross.prototype.getLegendLine = function() {
  let interval = 70;

  let legendH = 20;
  let xLine = this.xStandardLine;
  if (this.mode === "mb") {
    interval = 30;
    legendH = 10;
    xLine = this.xStandardLineMb;
  }
  let values = [];
  if (this.isFldStg && this.yStandard[4]) {
    var val4 = {
      x1: this.legendScroll + this.xLegend + this.xStandardProd,
      y1: yLegend + legendH,
      x2: this.legendScroll + this.xLegend + this.xStandardProd + xLine,
      y2: this.yStandard[4],
      class: "legend-stroke",
    };
    values.push(val4);
    legendH += interval;
  }

  if (this.cross.sys === "sw" && this.mode === "mb") {
    legendH += interval;
  }

  if (this.isLv4) {
    var val3 = {
      x1: this.legendScroll + this.xLegend + this.xStandardProd,
      y1: yLegend + legendH,
      x2: this.legendScroll + this.xLegend + this.xStandardProd + xLine,
      y2: this.yStandard[3],
      class: "legend-stroke",
    };
    values.push(val3);
  }
  legendH += interval;

  if (this.cross.sys !== "sw") {
    if (this.isLv3) {
      var val2 = {
        x1: this.legendScroll + this.xLegend + this.xStandardProd,
        y1: yLegend + legendH,
        x2: this.legendScroll + this.xLegend + this.xStandardProd + xLine,
        y2: this.yStandard[2],
        class: "legend-stroke",
      };
      values.push(val2);
    }
    legendH += interval;
  }

  if (this.isLv2) {
    var val1 = {
      x1: this.legendScroll + this.xLegend + this.xStandardProd,
      y1: yLegend + legendH,
      x2: this.legendScroll + this.xLegend + this.xStandardProd + xLine,
      y2: this.yStandard[1],
      class: "legend-stroke",
    };
    values.push(val1);
  }
  legendH += interval;

  if (this.cross.sys !== "sw") {
    if (this.isLv1) {
      var val0 = {
        x1: this.legendScroll + this.xLegend + this.xStandardProd,
        y1: yLegend + legendH,
        x2: this.legendScroll + this.xLegend + this.xStandardProd + xLine,
        y2: this.yStandard[0],
        class: "legend-stroke",
      };
      values.push(val0);
    }
  }
  return values;
};

/**
 * 凡例プロットを描画
 */
DrawCross.prototype.getLegendCircle = function() {
  let interval = 70;
  let legendH = 20;
  let rProto = 10;
  if (this.mode === "mb") {
    legendH = 15;
    interval = 30;
    rProto = 8;
  }

  var values = [];
  if (this.isFldStg) {
    var val5 = {
      cx: this.legendScroll + this.xLegend + this.xStandardProd,
      cy: yLegend + legendH,
      r: rProto,
      class: "legend-lv-5",
    };
    values.push(val5);
    legendH += interval;
  }

  if (this.cross.sys === "sw" && this.mode === "mb") {
    legendH += interval;
  }

  var val4 = {
    cx: this.legendScroll + this.xLegend + this.xStandardProd,
    cy: yLegend + legendH,
    r: rProto,
    class: "legend-lv-4",
  };
  legendH += interval;
  values.push(val4);

  if (this.cross.sys !== "sw") {
    var val3 = {
      cx: this.legendScroll + this.xLegend + this.xStandardProd,
      cy: yLegend + legendH,
      r: rProto,
      class: "legend-lv-3",
    };
    legendH += interval;
    values.push(val3);
  }

  var val2 = {
    cx: this.legendScroll + this.xLegend + this.xStandardProd,
    cy: yLegend + legendH,
    r: rProto,
    class: "legend-lv-2",
  };
  legendH += interval;
  values.push(val2);
  if (this.cross.sys !== "sw" && this.isFldCtl) {
    var val1 = {
      cx: this.legendScroll + this.xLegend + this.xStandardProd,
      cy: yLegend + legendH,
      r: rProto,
      class: "legend-lv-1",
    };
    values.push(val1);
  }
  return values;
};

/**
 * 各ラベルを描画
 */
DrawCross.prototype.getText = function() {
  var values = [];
  if (this.cross.drawType != 2 && this.scrollMode) {
    // <<Aラベルを追加
    var labelA = "<<Ａ";
    var dxA = -60;
    if (this.cross.dispP == 1) {
      labelA = "<<現在地";
      dxA = -110;
    }
    var valA = {
      x: this.xLeftBank,
      y: this.viewBoxHeight - this.lowHeight - 10,
      dx: dxA,
      class: "label",
      label: labelA,
    };
    values.push(valA);
    // B>>ラベルを追加
    var labelB = "Ｂ>>";
    if (this.cross.dispP == 2) {
      labelB = "現在地>>";
    }
    var valB = {
      x: this.xRightBank,
      y: this.viewBoxHeight - this.lowHeight - 10,
      dx: 80,
      class: "label",
      label: labelB,
    };
    values.push(valB);
  }

  // 特殊横断以外の場合は現在地点ラベル、A・B点ラベルを描画
  if (this.cross.drawType != 2) {
    // 現在地点のELラベルを追加
    if (this.cross.isDispPresent) {
      var valElP = {
        x: this.xLabelElParent,
        y: this.yLabelElParent - 10,
        dx: this.dxLabelElParent,
        class: "label",
        label: this.labelElParent,
      };
      values.push(valElP);
    }

    // A地点のELラベルを追加
    var valElA = {
      x: this.xLabelElA,
      y: this.viewBoxHeight - this.lowHeight - 10,
      dx: 20,
      class: "label",
      label: this.labelElA,
    };
    values.push(valElA);
    // B地点のELラベルを追加
    var valElB = {
      x: this.xLabelElB,
      y: this.viewBoxHeight - this.lowHeight - 10,
      dx: -160,
      class: "label",
      label: this.labelElB,
    };
    values.push(valElB);
    var yElLabel = 0;
    if (this.yLabelElStage != null) {
      yElLabel = this.yLabelElStage;
    }
    // 水位のELラベルを追加
    var valElStage = {
      id: "label_el_stage",
      x: this.xLabelElA,
      y: yElLabel - 10,
      dx: 20,
      class: "label label-el-stage",
      label: this.labelElStage,
    };

    values.push(valElStage);
  } else {
    // 水位のELラベルを追加
    var yElLabelSp = 0;
    if (this.yLabelElStage != null) {
      yElLabelSp = this.yLabelElStage;
    }
    var valElStageSp = {
      id: "label_el_stage",
      x: 20,
      y: yElLabelSp - 10,
      dx: 20,
      class: "label label-el-stage",
      label: this.labelElStage,
    };
    values.push(valElStageSp);
  }

  // 水位のラベルを追加
  let classLabelStage = "label-stage";
  if (this.mode === "mb") {
    classLabelStage = "label-stage-mb";
  }
  var valStage = {
    id: "label_stage",
    x: this.xLabelStage,
    y: 100,
    dx: -200,
    class: classLabelStage,
    label: this.labelStage,
  };
  values.push(valStage);

  // 零点高のラベルを追加
  if (this.stgMode === "0" && this.cross.zeroHighFix != null) {
    let valZero = {
      id: "label_stage",
      x: this.xLeftBank,
      y: this.yZero + 30,
      dx: 20,
      class: "label label-zero",
      label:
        "水位標のゼロ点高(EL=" +
        Math.round(this.cross.zeroHighFix * 100) / 100 +
        "m)",
    };
    values.push(valZero);
  }

  return values;
};

/**
 * <line>タグを追加
 * @param {*} g
 * @param {*} lines
 */
function appendLine(g, lines) {
  for (var i = 0; i < lines.length; i++) {
    var line = document.createElement("line");
    if (lines[i].id) {
      line.setAttribute("id", lines[i].id);
    }
    line.setAttribute("x1", lines[i].x1);
    line.setAttribute("y1", lines[i].y1);
    line.setAttribute("x2", lines[i].x2);
    line.setAttribute("y2", lines[i].y2);
    line.setAttribute("class", lines[i].class);
    g.appendChild(line);
  }
}

/**
 * <image>タグを追加
 * @param {*} g
 * @param {*} images
 */
function appendImage(g, images) {
  for (var i = 0; i < images.length; i++) {
    var image = document.createElement("image");
    image.setAttribute("x", images[i].x);
    image.setAttribute("y", images[i].y);
    image.setAttribute("width", images[i].width);
    image.setAttribute("xlink:href", images[i].xlinkhref);
    g.appendChild(image);
  }
}

/**
 * <text>タグを追加
 * @param {*} g
 * @param {*} texts
 */
function appendText(g, texts) {
  for (var i = 0; i < texts.length; i++) {
    var text = document.createElement("text");
    if (texts[i].id) {
      text.setAttribute("id", texts[i].id);
    }
    text.setAttribute("x", texts[i].x);
    text.setAttribute("y", texts[i].y);
    text.setAttribute("dx", texts[i].dx);
    text.setAttribute("class", texts[i].class);
    text.appendChild(document.createTextNode(texts[i].label));
    g.appendChild(text);
  }
}

/**
 * <rect>タグを追加
 * @param {} g
 * @param {*} rect
 */
function appendRect(g, rect) {
  var elmRect = document.createElement("rect");
  elmRect.setAttribute("id", rect.id);
  elmRect.setAttribute("x", rect.x);
  elmRect.setAttribute("y", rect.y);
  elmRect.setAttribute("width", rect.width);
  elmRect.setAttribute("height", rect.height);
  elmRect.setAttribute("class", "legend");
  // elmRect.onclick = clickLegend;
  g.appendChild(elmRect);
}

/**
 * <circle>タグを追加
 * @param {*} g
 * @param {*} circles
 */
function appendCircle(g, circles) {
  for (var i = 0; i < circles.length; i++) {
    var circle = document.createElement("circle");
    circle.setAttribute("cx", circles[i].cx);
    circle.setAttribute("cy", circles[i].cy);
    circle.setAttribute("r", circles[i].r);
    circle.setAttribute("class", circles[i].class);
    g.appendChild(circle);
  }
}

/**
 * 空チェック
 * @param {} value
 */
function isEmpty(value) {
  if (value === undefined) return true;
  if (value === null) return true;
  if (value === false) return true;
  if (value === true) return false;
  if (typeof value === "object") return value.length === 0;
  if (typeof value === "string") return value.replace(/\s+/gi, "").length === 0;
  if (typeof value === "number") return false;
  if (typeof value === "function") return false;
}

/**
 * 切り落とし終了idx取得
 * @param {*} points 標高データ
 * @param {*} left 左岸インデックス
 * @param {*} right 右岸インデックス
 * @param {*} str 観測開始水位
 */
function getEndIdx(points, left, right, str) {
  let endIdx = false;
  for (var i = left + 1; i < right; i++) {
    if (points[i].h < str) {
      endIdx = i;
    }
  }
  return endIdx;
}
